import { ContentDataBlockAlert } from '@amf/shared/components/content/Content';

interface AlertProps {
  block: ContentDataBlockAlert;
}

export default function Alert({ block }: AlertProps) {
  return (
    <div className='Content__alert'>
      <div className='Content__alertTitle'>{block.data.title}</div>
      <p
        className='Content__alertMessage'
        dangerouslySetInnerHTML={{ __html: block.data.message }}
      />
    </div>
  );
}
